import { ILocation, UserProfileRole } from 'lib/types/user';

export enum CombinationOperator {
  AND = 'AND',
  OR = 'OR',
}

export enum PopulationRuleType {
  CUSTOM_CATEGORY = 'CUSTOM_CATEGORY',
  DEPARTMENT = 'DEPARTMENT',
  EMPLOYEE_TYPE = 'WORKER_TYPE',
  LOCATION = 'LOCATION',
  ROLE = 'ROLE',
}

export interface IPopulationRulesBuilderValue {
  combinationOperator?: CombinationOperator;
  customCategoryFilter?: { customCategoryValues: string[]; exclude?: boolean };
  departmentFilter?: { departments: string[]; exclude?: boolean };
  employeeTypeFilter?: { employeeTypes: string[]; exclude?: boolean };
  locationFilter?: { locations: ILocation[]; exclude?: boolean };
  roleFilter?: UserProfileRole;
}
